import React from 'react';
import Hero from './components/viksit-bharat/Hero';
import Main from './components/viksit-bharat/Main';

const ViksitBharat = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default ViksitBharat;